
    import Vue from 'vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import MailService from '@/apps/shared/services/email-service';
    import FilePathService from '@/apps/shared/services/filePath-service';
    import ParamCotizService from '@/apps/shared/services/ParamCotizOfSession-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';

    interface sessionPayload {
        productId: string;
        pricingId?: number;
        contratante: {
            firstName: string;
            lastName: string;
            documentNumber: string;
            documentType: string;
            areaCode: string;
            telephone: string;
            email: string;
        };
        plan: {
            PlanName: string;
            premioMensual: string;
        };
        vigency: {
            start: string;
            end: string;
        };
        localityId: number;
        quotaQuantity: string;
        peopleToCover: number;
        activity: string;
        referente: string;
    }

    interface getParamCotizResponse {
        hasData: boolean;
        message: string;
        data: string | null;
    }

    export default Vue.extend({
        name: 'APFinalPayment',
        data() {
            return {
                sessionData: null as sessionPayload | null,
                externalIdentifier: '' as string,
                product: '' as string,
                productName: null,
            };
        },
        methods: {
            fetchSessionPayload(guid: string): Promise<getParamCotizResponse> {
                return ParamCotizService.getParamCotiz(guid);
            },
            
            async pageCustomization() {
                const product = this.sessionData!.productId;
                let defaultTitle = '';
                let actualPath = '';
                switch (product) {
                    case '711': defaultTitle = 'Integro Max'; this.productName = "apintegro"; actualPath = '/integro-max'; break;
                    case '555': defaultTitle = 'Ocasión de Trabajo'; this.productName = "aptrabajo"; actualPath = '/ocasion-de-trabajo'; break;
                    case '387': defaultTitle = 'AP - 24HS'; this.productName = "ap24"; actualPath = '/ap-24-hs'; break;
                }
                this.product = product;                
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'Default' + this.productName + 'GTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            getFilePath() {
                FilePathService.getFilePath('UrlBase')
                    .then(baseUrl => {
                        let url = '';
                        switch (this.sessionData!.productId) {
                            case '711': url = 'integro-max'; break;
                            case '555': url = 'ocasion-de-trabajo'; break;
                            case '387': url = 'ap-24-hs'; break;
                        }
                        window.location.href = `${baseUrl}${url}`;
                    });
            },

            formatDate(dateString: string) {
                const [year, month, day] = dateString
                    .split('T')[0]
                    .split('-');
                return `${day}/${month}/${year}`;
            },

            getMailValues() {
                const c = this.sessionData!.contratante;
                const p = this.sessionData!.plan;
                const from = this.formatDate(this.sessionData!.vigency.start);
                const to = this.formatDate(this.sessionData!.vigency.end);

                let firstName = ""

                if (c.documentType != "J") {
                    firstName = c.firstName
                        .toLowerCase()
                        .split(' ')[0]
                        .replace(/^./, s => s.toUpperCase());
                }
                else {
                    firstName = c.lastName.toLowerCase()
                        .replace(/\b\w/g, (char) => char.toUpperCase());
                }

                var request = JSON.stringify({
                    parameters: [
                        { name: '@ReportCode', value: "1" },
                        { name: '@contratante', value: firstName },
                        { name: '@nombrePlan', value: p.PlanName },
                        { name: '@vigenciaDesde', value: from },
                        { name: '@vigenciaHasta', value: to },
                        { name: '@costoMensual', value: "$ " + p.premioMensual },
                        { name: '@actividad', value: this.sessionData.activity },
                        { name: '@cantidadAsegurados', value: this.sessionData.peopleToCover.toString() },
                        { name: '@frecuenciaPago', value: this.sessionData.quotaQuantity == "1" ? "Precio final" : "Final por mes" },
                        { name: '@precioLabel', value: this.sessionData.quotaQuantity == "1" ? "" : "Costo final por mes" },
                    ],
                    to: c.email,
                    from: 'cotizador@sancorseguros.com',
                    productId: Number(this.sessionData!.productId)
                });

                return request;
            },
        },

        mounted: async function (): Promise<void> {
            const guid = sessionStorage.getItem('ParamId');
            if (!guid) {
                console.error('No hay ParamId en sessionStorage');
                return;
            }

            try {
                const resp = await this.fetchSessionPayload(guid);
                if (!resp.hasData || !resp.data) {
                    console.warn(resp.message);
                    throw new Error(resp.message);
                }

                const parsed = JSON.parse(resp.data) as sessionPayload;
                this.sessionData = parsed;
                this.externalIdentifier = parsed.pricingId!.toString();
                this.product = parsed.productId;

                await this.pageCustomization();
                this.updateByProductGoogleAnalytics();

                sessionStorage.setItem('ExitOrContinueModal', 'true');

                const p = this.sessionData!.plan;
                const ramo = 'AP';
                const premiostr = p.premioMensual.replaceAll('.', '');
                const contratanteData = JSON.parse(sessionStorage.getItem('contratante'));
                const finishResult = await CUPEService.Finish(
                    parseInt(this.externalIdentifier, 10),
                    parseInt(this.product, 10),
                    contratanteData.lastName,
                    contratanteData.document.identificationNumber,
                    contratanteData.localityName,
                    JSON.parse(sessionStorage.getItem('TabOneWelcome')).email,
                    contratanteData.firstName,
                    this.externalIdentifier,
                    parseInt(premiostr, 10),
                    p.PlanName,
                    ramo,
                    contratanteData.areaCode,
                    contratanteData.telephone
                );

                if (finishResult) {
                    NF.UI.Page.block();
                    window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                    window.globalThis.dataLayer.push({
                        pas: null,
                        email: this.sessionData.contratante.email,
                        product: this.productName,
                        event: 'cotizador-' + this.productName + '-venta-completa',
                        value: parseInt(this.sessionData!.plan.premioMensual.replaceAll('.', ''), 10) ,
                        referente: this.sessionData!.referente
                    });

                    const mailResp = await MailService.sendMail(this.getMailValues());
                    if (mailResp) {
                        NF.Notification.show({
                            type: mailResp.result ? NF.Notification.Type.SUCCESS : NF.Notification.Type.ERROR,
                            title: mailResp.result ? 'Mail Enviado' : 'Error',
                            content: mailResp.result ? 'Mail enviado exitosamente.' : 'Se produjo un error inesperado.',
                            position: NF.Notification.Positions.TOP_RIGHT,
                            clickClose: true,
                            autoHideDelay: 10000
                        });

                        webSaleHelper.deleteSessions();
                    }
                    NF.UI.Page.unblock();
                }
            } catch (err) {
                console.error('Error:', err);
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                window.globalThis.dataLayer.push({
                    pas: null,
                    email: this.sessionData.contratante.email,
                    product: this.productName,
                    event: 'errorUsuario',
                    paso: 'cotizador-' + this.productName + '-checkout',
                    referente: this.sessionData!.referente
                });
                NF.UI.Page.unblock();
            }
        }
    });
